import { useState, useMemo } from "react";

import FilterChip from "../../layouts/FilterChip";
import Flex from "../../layouts/Flex";
import Text from "../../layouts/Text";
import DropdownWithSearch from "../DropdownWithSearch";
import Dropdown from "../../layouts/Dropdown";

import { TagFilter as TagFilterType } from "../../providers/types";

const TagFilter = ({
  options,
  tagList,
  setTagList,
  removeFilter,
}: {
  options: TagFilterType[];
  tagList: TagFilterType[];
  setTagList: (t: TagFilterType[]) => void;
  removeFilter: () => void;
}) => {
  const [keyword, setKeyword] = useState("");

  const filteredTagOptions = useMemo(() => {
    return options.filter((species) => species.name.includes(keyword));
  }, [keyword, options]);

  return (
    <Dropdown
      position="left"
      trigger={
        tagList.length > 0 ? (
          <FilterChip
            size="S"
            type="selected"
            onClick={() => {}}
            suffixIcon="/icons/active_arrow_drop_down.svg"
            suffixIconSize={18}
          >
            {`고객 태그 : ${tagList.map((s) => s.name).join(", ")}`}
          </FilterChip>
        ) : (
          <FilterChip
            size="S"
            onClick={() => {}}
            suffixIcon="/icons/navigation/arrow_drop_down.svg"
            suffixIconSize={18}
          >
            고객 태그
          </FilterChip>
        )
      }
      renderOptions={({ close }) => (
        <DropdownWithSearch
          keyword={keyword}
          setKeyword={setKeyword}
          resetSelect={() => setTagList([])}
          removeFilter={() => {
            removeFilter();
            close();
          }}
        >
          {(keyword ? filteredTagOptions : options).map((i) => (
            <DropdownWithSearch.ListItem
              key={i.id}
              selected={!!tagList.find((s) => s.id === i.id)}
              handleClick={() => {
                let newTags = [...tagList];

                if (tagList.find((s) => s.id === i.id)) {
                  newTags = newTags.filter((s) => s.id !== i.id);
                } else {
                  newTags.push(i);
                }

                setTagList(newTags);
              }}
            >
              <Flex
                p-8-rl
                p-2-tb
                bdr-8
                style={{ backgroundColor: i.color.bgColor }}
              >
                <Text t-14-500 style={{ color: i.color.textColor }}>
                  {i.name}
                </Text>
              </Flex>
            </DropdownWithSearch.ListItem>
          ))}
          {keyword && filteredTagOptions.length <= 0 && (
            <DropdownWithSearch.EmptySearchResult />
          )}
        </DropdownWithSearch>
      )}
    />
  );
};

export default TagFilter;
